module.exports = __webpack_public_path__ + "static/media/dcu.bcc1044f.png";